import React, { useState, useEffect } from "react";
import { Box, Typography, Stack, Button } from "@mui/material";

import { Link, useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { signUpSchema } from "../../validate/authentication";
import { EmailInput, PasswordInput } from "../ui-elements/inputs";

import {
  btnApple,
  btnGoogle,
  btnStyOne,
  line,
  lineText,
} from "../ui-elements/styles-button";
import { Image } from "@mui/icons-material";
import { Apple, Google } from "../ui-elements/svg-icons";
import { PATH_AUTH, PATH_ONBOARD } from "../../routes/path";
import { useMutation } from "@tanstack/react-query";
import { useNotificationService } from "../../hooks/notification";
import { apiSignUp } from "../../api/authentication";
import { LoadingButton } from "@mui/lab";
import { AuthProps } from "../../interface/api";

export const SignupDetails = ({}) => {
  // set up validation
  const navigate = useNavigate();
  const { showNotification } = useNotificationService();
  const {
    register,
    formState: { errors, isSubmitSuccessful },
    handleSubmit,
  } = useForm({
    resolver: zodResolver(signUpSchema),
  });
  const [email, setEmail] = useState("");
  const mutation = useMutation({
    mutationFn: (fields: AuthProps) => apiSignUp(fields),
    onSuccess: async (data) => {
      if (data?.status === "error") {
        
        if ("details" in data) {
          showNotification(data?.details ?? "", "error");
          return;
        }
        return;
      }
      if ("data" in data) {
        showNotification(data?.data?.details ?? "Otp sent to email", "success");
        navigate(PATH_AUTH.otp, {
          state: {
            email: email,
          },
        });
      }
    },
    onError: (error) => {
      showNotification("Process failed", "error");
    },
  });
  const on_submit = async (values: any): Promise<void> => {
    const { email, password } = values;
    setEmail(email);
    const data = { password: password, email: email };

    mutation.mutate(data);
  };
  return (
    <Box sx={{ width: "80%", mx: "auto" }}>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit(on_submit)}
      >
        <EmailInput
          errors={errors}
          labelText="Email"
          placeholder="Enter email"
          register={register}
        />
        <PasswordInput
          errors={errors}
          placeholder="Enter password"
          labelText="Password"
          register={register}
        />
        <LoadingButton
          loading={mutation.isPending}
          type="submit"
          variant="contained"
          sx={btnStyOne}
        >
          Create Account
        </LoadingButton>
        <Box sx={{height: 100}} />
        {/* <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{
            my: 1,
          }}
        >
          <Box sx={line} />
          <Typography sx={lineText}>or</Typography>
          <Box sx={line} />
        </Box>
        <Box>
          <Button startIcon={<Google />} sx={btnGoogle}>
            Continue with Google
          </Button>

          <Button startIcon={<Apple />} sx={btnApple}>
            Continue with Apple ID
          </Button>
        </Box> */}
      </Box>
    </Box>
  );
};
